<template>
    <v-container id="datosEjec">
        <v-card flat class="text-xs-center" width="100%">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Datos Ejecutivo</v-toolbar-title>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <vs-list-item v-if="this.ejecutivo != null" title="Ejecutivo: "
                    :subtitle="this.ejecutivo"></vs-list-item>
                <vs-list-item id="correo" title="Correo de Ejecutivo de Cuenta: "
                    :subtitle="this.clcorreoalertas"></vs-list-item>
                <div v-for="(telefono, index) in telefonos" :key="index">
                    <vs-list>
                        <v-list-item-content>
                            <v-list-item-subtitle>

                                <vs-col vs-lg="7" style="margin-top: 5px;">
                                    <v-icon color="indigo">{{ telefono.icon }} </v-icon>
                                    <span v-if="permisoIVR != false && perfil != 'E'" class="hoverTel"
                                        style="font-size: 15.5px; text-align: center;"
                                        v-on:click="LlamadaIVR(telefono)">
                                        {{ telefono.coprefijo }} {{ telefono.codato }}
                                    </span>
                                    <span v-else style="font-size: 15.5px; text-align: center;">

                                        {{ telefono.coprefijo }} {{ telefono.codato }}
                                    </span>
                                </vs-col>

                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </vs-list>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Ejecutivo from '@/services/DatosEjecutivo/DatosEjecutivo.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Contacto from '@/services/DatosDeContacto/DatosContacto.service.js';
export default {
    data: function () {
        return {
            datos: {},
            ejecutivo: null,
            telefonos: [],
            clcorreoalertas: null,
            //Datos para IVR
            permisoIVR: false,
            ivr: null,
            LLamarSintiempo: false,
            perfil: ''
        };
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        },
    },
    methods: {
        async DatosEjecutivo() {
            let datosejecutivo = await Ejecutivo.DatosEjecutivo(this, this.datos).then()
            for (const [key, value] of Object.entries(datosejecutivo)) {
                if (typeof value == "object") { datosejecutivo[key] = "" } else { datosejecutivo[key] = value.toString() }
            }
            this.ejecutivo = datosejecutivo.nombreejecutivo;
            this.clcorreoalertas = datosejecutivo.clcorreoalertas;
            let auxtelefonos = await Ejecutivo.TelefonosEjecutivo(this, this.datos);
            for (let i in auxtelefonos) {
                for (const [key, value] of Object.entries(auxtelefonos[i])) {
                    if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                }
            }
            this.telefonos = auxtelefonos;
            let response = await Ejecutivo.ObtenerPerfil(this);
            this.perfil = response.usperfil
        },
        async LlamadaIVR(telefono) {
            let actor = await Ejecutivo.ObtenerTipoActor(this, 'Ejecutivo');
            /*  -----Actor----
            ---1 ==> Asegurado *
            ---2 ==> Ejecutivo ok
            ---3 ==> Abogado   ok
            ---4 ==> Supervisor ok ??
            ---5 ==> Gerente ok
            ---6 ==> Supervisor de vehiculo ??
            ---7 ==> Administrativo ok
            ---8 ==> Cliente *
            ---9 ==> Ajustador
            ---10 ==> Tercero */
            //this.$store.state.ivr
            Ejecutivo.LlamadaIVRServ(this, telefono.codato, actor, this.datos).then(datostel => {
                if (datostel !== null) {
                    window.location = 'tel:' + datostel;
                }
            })
        },
    },
    async mounted() {

        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.DatosEjecutivo();

        let responseIVR = await Contacto.ObtenerCodigoIVR(this); //ObtenerIVR
        this.ivr = responseIVR[0].IVR;
        if (responseIVR[0].SINTIEMPO == 'SI') {
            this.LLamarSintiempo = true;
        }
        let diasConclu = await Contacto.ObtenerDiasConcluidos(this);

        if (this.ivr != 0 && diasConclu < 30) {
            //Habilitar permiso IVR
            this.permisoIVR = true;
        }
        else if (this.LLamarSintiempo && this.ivr != 0) {
            this.permisoIVR = true;
        }
    }

}
</script>
<style lang="scss">
.hoverTel:hover {
    background-color: lightskyblue;
    cursor: pointer;
}

@media screen and (max-width: 600px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 0.6rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 0.7rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 600px) and (max-width: 960px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 0.7rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 0.8rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 960px) and (max-width: 1264px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 0.8rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 0.9rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1264px) and (max-width: 1904px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 0.9rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1904px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1.2rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.3rem;
        font-weight: 700;
    }
}

#correo .list-titles {
    max-width: -webkit-fill-available !important;
}
</style>
